import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import * as Sentry from '@sentry/nextjs';
import { SentryEventEnum } from '@lib/enums/SentryEventEnum';

// All fields are optional in Sentry.Event by default.
// Use this type to enforce minimum data provided to event
type TSentryEvent = {
  level: Sentry.SeverityLevel;
  message: string;
  type: SentryEventEnum;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;
};
type Sentry = typeof Sentry;
export type TUseSentry = Omit<Sentry, 'captureEvent'> & {
  captureAuthError: (error: unknown) => void;
  captureEvent: (event: TSentryEvent) => string;
};
export function useSentry() {
  const $ = _c(2);
  const captureEvent = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = error => {
      if (error == null) {
        return;
      }
      Sentry.captureException(error);
      return captureEvent({
        level: "error",
        message: "Unhandled auth error",
        type: SentryEventEnum.AuthError,
        data: {
          error
        }
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const captureAuthError = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...Sentry,
      captureAuthError,
      captureEvent
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(event) {
  return Sentry.captureEvent({
    level: event.level,
    message: event.message,
    tags: {
      type: event.type
    },
    extra: event?.data
  });
}